import { createRoute } from "./createRouter";

const routes = [createRoute("/dev/docs", "", () => import("../components/dev/Dev.vue")), createRoute("/dev/downloads", "", () => import("../components/dev/Downloads.vue"))];

export default routes;
